import { Reducer } from 'redux';
import { update } from '../helpers/immutabilityHelper'
import * as Dtos from '../dtos/Tmd.dtos';

import {
    TrialGroupItemCategoryActions,
    ACTION_TRIALGROUPITEMCATEGORIES_LOAD_BY_TRIALGROUPID,
    ACTION_TRIALGROUPITEMCATEGORIES_LOAD_BY_TRIALGROUPID_SUCCESS,
    ACTION_TRIALGROUPITEMCATEGORIES_LOAD_BY_TRIALGROUPID_FAILURE,
    ACTION_TRIALGROUPITEMCATEGORIES_CLEAR,
    ACTION_TRIALGROUPITEMCATEGORIES_FILTER
} from '../actions/trialGroupItemCategory';
import { RequestState } from "../enumerations/RequestState";
import { IRequestState, IFormFilter } from "./index";
import { updateFailureIndexToId } from "../helpers/formErrorHelper";

export interface ITrialGroupItemCategoryState {
    formData: Dtos.TrialGroupItemCategory[],
    formState: Dtos.FormState,
    formProperties: Dtos.FormProperty[],
    lookups: Dtos.Lookup[],
    loadState: IRequestState;
    formFilter: IFormFilter;
    formFilteredData: Dtos.TrialGroupItemCategory[];
    formLength: number;
}

const initialState: ITrialGroupItemCategoryState = {
    formData: undefined,
    formState: undefined,
    formProperties: undefined,
    lookups: undefined,
    loadState: {
        status: RequestState.None
    } as IRequestState,
    formFilter: {
        search: "",
        showInActive: false
    },
    formFilteredData: [],
    formLength: 0
};


function loading(state: ITrialGroupItemCategoryState, _isLoading: boolean): ITrialGroupItemCategoryState {
    const newState: ITrialGroupItemCategoryState = update(state, {
        loadState: {
            $set: {
                status: RequestState.Pending
            } as IRequestState
        }
    });

    return newState;
}

function loadSuccess(state: ITrialGroupItemCategoryState,
    formData: Dtos.TrialGroupItemCategory[],
    formProperties: Dtos.FormProperty[],
    lookups: Dtos.Lookup[],
    responseStatus: Dtos.ResponseStatus
): ITrialGroupItemCategoryState {
    const newState: ITrialGroupItemCategoryState = update(state, {
        formData: {
            $set: formData
        },
        formProperties: {
            $set: formProperties
        },
        lookups: {
            $set: lookups
        },
        loadState: {
            $set: {
                status: RequestState.Success,
                errorCode: responseStatus ? responseStatus.errorCode : undefined,
                errorMessage: responseStatus ? responseStatus.message : undefined,
                errors: responseStatus ? responseStatus.errors : undefined,
                meta: responseStatus ? responseStatus.meta : undefined
            } as IRequestState
        },
        validationFailures: {
            $set: responseStatus ? updateFailureIndexToId(responseStatus.errors, formData) : undefined
        }
    });

    return filter(newState, state.formFilter);
}

function filter(state: ITrialGroupItemCategoryState, formFilter: IFormFilter): ITrialGroupItemCategoryState {

    const trialItemCategories: Dtos.TrialGroupItemCategory[] | undefined =
        state.formData instanceof Array ?
            state.formData :
            undefined;

    const formLength = trialItemCategories ? trialItemCategories.length : 0;

    const formFilteredData = trialItemCategories ? trialItemCategories.filter(p => (formFilter.showInActive) &&
        (formFilter.search == "" || p.trialGroupItemTemplateCategory.value.toLowerCase().indexOf(formFilter.search.toLowerCase()) > -1)) : undefined;

    const newState: ITrialGroupItemCategoryState = update(state, {
        formFilter: {
            $set: formFilter
        },
        formFilteredData: {
            $set: formFilteredData
        },
        formLength: {
            $set: formLength
        }
    });

    return newState;
}

function loadFailure(state: ITrialGroupItemCategoryState, responseStatus: Dtos.ResponseStatus): ITrialGroupItemCategoryState {
    const newState: ITrialGroupItemCategoryState = update(state, {
        loadState: {
            $set: {
                status: RequestState.Failure,
                errorCode: responseStatus.errorCode,
                errorMessage: responseStatus.message,
                errors: responseStatus.errors
            } as IRequestState
        }
    });

    return newState;
}

function clear(state: ITrialGroupItemCategoryState, propertiesToClear?: string[]): ITrialGroupItemCategoryState {

    if (!propertiesToClear) {
        const newState: ITrialGroupItemCategoryState = update(initialState, {});
        return newState;
    }

    let stateModifier: any = {};

    propertiesToClear.forEach(propertyToClear => {
        stateModifier[propertyToClear] = { $set: initialState[propertyToClear] }
    });

    const newState = update(state, stateModifier);

    return newState;
}

const TrialGroupItemCategoryReducer: Reducer<ITrialGroupItemCategoryState> = (state: ITrialGroupItemCategoryState = initialState, action: TrialGroupItemCategoryActions) => {
    switch (action.type) {
        case ACTION_TRIALGROUPITEMCATEGORIES_LOAD_BY_TRIALGROUPID:
            return loading(state, true);
        case ACTION_TRIALGROUPITEMCATEGORIES_LOAD_BY_TRIALGROUPID_SUCCESS:
            return loadSuccess(state, action.formData, action.formProperties, action.lookups, action.responseStatus);
        case ACTION_TRIALGROUPITEMCATEGORIES_LOAD_BY_TRIALGROUPID_FAILURE:
            return loadFailure(state, action.responseStatus);
        case ACTION_TRIALGROUPITEMCATEGORIES_CLEAR:
            return clear(state, action.propertiesToClear);
        case ACTION_TRIALGROUPITEMCATEGORIES_FILTER:
            return filter(state, action.formFilter);
    }

    return state;
}

export default TrialGroupItemCategoryReducer;